import {SingleValue} from 'react-select'
import {CountryCode} from 'libphonenumber-js'
import {FetchVenuesResponse as Address} from './services'

export interface AddressesArray extends Array<Address> {}

export enum CurrentlyDisplayedPage {
  ChooseLocation = 'ChooseLocation',
  EnterQuantities = 'EnterQuantities',
}

// To keep our code DRY, we want to list the form values here only. We need not
// only an interface but also an array of the interface's string keys, so we can
// do things like iterate over those strings when rendering the form in JSX.
// Typescript doesn't easily allow for getting the string keys of an interface,
// so we use this workaround with a class. We never use this class outside of
// this file, we only use it to create the interface and array below. Solution
// from https://stackoverflow.com/a/59806829
class EmptyKegsFormClass {
  '20L' = ''
  '30L' = ''
  '50L' = ''
  '9G' = ''
}
export interface EmptyKegsForm extends EmptyKegsFormClass {}
// an array of EmptyKegsForm string keys
type EmptyKegsFormKeys = Array<keyof EmptyKegsForm>
export const EmptyKegsFormKeysArray: EmptyKegsFormKeys = Object.keys(
  new EmptyKegsFormClass()
) as EmptyKegsFormKeys

export interface PickupRequestBody {
  customerId: string
  addressId: string
  venueOpenMonday: boolean
  venueOpenTuesday: boolean
  venueOpenWednesday: boolean
  venueOpenThursday: boolean
  venueOpenFriday: boolean
  startHour: number
  endHour: number
  kegLocation: string
  quantity20L: number
  quantity30L: number
  quantity50L: number
  quantity9G: number
  pickupInstruction: string
  phoneNumber: string
}

export type KegLocation = 'Inside' | 'Out the Front' | 'Out the Back'

// Defines the shape of the venue submission form state
export interface VenueSubmissionFormState {
  region: 'UKE' | 'AUS' | 'NZ'
  venueName: string
  address: {
    addressLine1: string
    addressLine2?: string
    city: string
    postalCode: string
    stateOrProvince: SingleValue<{value: string; label: string}>
    country: SingleValue<{
      value: string
      label: string
    }>
  }
  contact: {
    contactName: string
    contactEmail: string
    contactPhone: string
    phoneCountryCode?: CountryCode
  }
  additionalNotes?: string
  includeKegCollection: boolean
  collectionRequest: {
    venueOpenMonday: boolean
    venueOpenTuesday: boolean
    venueOpenWednesday: boolean
    venueOpenThursday: boolean
    venueOpenFriday: boolean
    startHour: number
    endHour: number
    kegLocation: KegLocation
    '20L': string
    '30L': string
    '50L': string
    '9G': string
    pickupInstructions: string
  }
}

export const daysOfWeek = {
  Monday: 'M',
  Tuesday: 'T',
  Wednesday: 'W',
  Thursday: 'T',
  Friday: 'F',
}
